import src from "IMAGE";
export default { src, width: 536, height: 398, blurWidth: 0, blurHeight: 0};
